import { useState } from 'react'
import Button from 'shared/components/Button'
import Input from 'shared/components/Input'

import logo from 'shared/assets/images/sparx-logo.png'

export default function IntroCodeEntry({ onSubmit }) {
  const [code, setCode] = useState('')

  function onCodeChange(e) {
    setCode(e.target.value)
  }

  return (
    <div className="drop-shadow-md lg:w-[470px] p-[24px] lg:py-[60px] lg:px-[42px] bg-white">
      <form
        className="w-full flex flex-col items-center"
        onSubmit={(e) => {
          e.preventDefault()
          onSubmit(code)
        }}
      >
        <div className='hidden lg:block'>
          <img src={logo} className="h-[39px]" alt="sparx-logo" />
        </div>
        <div className="text-center lg:mt-[48px] px-[38px] lg:px-0 text-[18px]">
          To view tour data please enter
          <br className='hidden lg:inline-block'/> the tour code:
        </div>
        <Input onChange={onCodeChange} value={code} placeholder="Tour code..." className="mt-[34px] lg:mt-[20px]" />
        <div className="mt-[24px] lg:mt-[41px] w-full lg:w-auto mb-[36px] lg:mb-0">
          <Button type="submit" className="w-full lg:w-[172px]">Continue</Button>
        </div>
      </form>
    </div>
  )
}
